@if (!hideTitle) {
  <h5><mibp-resource-string key="Quick-Add-Dashboard-Title"></mibp-resource-string></h5>
}

@if (!deliverySequence && isDeliverySequenceRequired && hasCreateCartPermission) {
  <mibp-system-message class="m-4">
    <mibp-resource-string key="Global_ActAsCustomerForFeature"></mibp-resource-string>
  </mibp-system-message>
}

@if ((deliverySequence || !isDeliverySequenceRequired) && hasCreateCartPermission) {
  <mibp-tabs 
    [scrollIntoView]="false"
    [automatedTestId]="'dashboard-quickadd'" #tabs 
    [noMargin]="compactLayout" 
    [compactLayout]="compactLayout" 
    [tabBgColor]="isOnTile == true ? 'secondary' : 'primary'">
    <mibp-tab [resourceKey]="'Quick-Add-Dashboard-Tab-Add'">
      @if (deliverySequence || !isDeliverySequenceRequired) {
        <div>
          <mibp-quick-add [compactLayout]="compactLayout" [multiRowQuickAdd]='true' [skipFocus]="skipFocus"></mibp-quick-add>
        </div>
      }
    </mibp-tab>
    @if (hasTemplatePermission) {
      <mibp-tab [resourceKey]="'Quick-Add-Dashboard-Tab-Template'">
        @if (deliverySequence) {
          <div>
            <mibp-quick-add-template></mibp-quick-add-template>
          </div>
        }
      </mibp-tab>
    }
    <mibp-tab [resourceKey]="'Quick-Add-Dashboard-Tab-Import'">
      @if (deliverySequence || !isDeliverySequenceRequired) {
        <div>
          <mibp-quick-add-import (importedFiled)='filesImported($event)'></mibp-quick-add-import>
        </div>
      }
    </mibp-tab>
  </mibp-tabs>
}
